module.exports = __webpack_public_path__ + "static/media/bootstrap.da53dc34.png";